import * as t from 'io-ts';

import {
  makeEnumRuntimeType,
  RCardIdRef,
  RCardNoteIdRef,
  RContactUidRef,
  RConversationIdRef,
} from '../../../models/api/apiTypes';
import {RDomain} from '../../../models/api/domainModel';
import {RAsyncStatus} from '../../appTypes';
import {RPanelCancelTokenId} from '../panelCancelTokenId';
import {PanelTypesEnum, RContactDetailsPanelId, RPanelStateBase} from '../panelStateBase';
import {RContactDetailsPanelSubState} from './contactDetailsPanelSubState';

/*
 * Runtime types.
 */

export enum ContactDetailsPanelLocationsEnum {
  INBOXES = 'INBOXES',
  CONTACTS_MANAGER = 'CONTACTS_MANAGER',
  POPOUT = 'POPOUT',
}
export const RPanelLocation = makeEnumRuntimeType(ContactDetailsPanelLocationsEnum);

export enum ContactDetailsScrollSectionsEnum {
  CONVERSATIONS = 'CONVERSATIONS',
  NOTES = 'NOTES',
}
export const RScrollSections = makeEnumRuntimeType(ContactDetailsScrollSectionsEnum);

export const RContactDetailsPanelStateDirty = t.intersection([
  RPanelStateBase,
  t.type({
    id: RContactDetailsPanelId,
    type: t.literal(PanelTypesEnum.CONTACT_DETAILS),
    location: RPanelLocation,
    status: t.union([RAsyncStatus, t.undefined]),
    notesStatus: t.union([RAsyncStatus, t.undefined]),
    conversationStatus: t.union([RAsyncStatus, t.undefined]),
    cancelTokenId: RPanelCancelTokenId,
    selectedContactUid: t.union([RContactUidRef, t.undefined]),
    selectedCardId: t.union([RCardIdRef, t.undefined]),
    cardIds: t.array(RCardIdRef),
    noteIds: t.union([t.array(RCardNoteIdRef), t.undefined]),
    conversationIds: t.union([t.array(RConversationIdRef), t.undefined]),
    hasMoreConversations: t.union([t.boolean, t.undefined]),
  }),
  t.partial({
    popupWidth: t.Integer,
    popupContactNamespace: t.string,
    popupConversationId: RConversationIdRef,
    subState: RContactDetailsPanelSubState,
    shouldHideHeaderTabs: t.boolean,
    // Account tab domain information.
    selectedDomain: RDomain,
    sectionToScrollTo: RScrollSections,
  }),
]);

/*
 * Types.
 */

export interface ContactDetailsPanelState extends Readonly<t.TypeOf<typeof RContactDetailsPanelStateDirty>> {}
export const RContactDetailsPanelState = t.clean<ContactDetailsPanelState>(
  RContactDetailsPanelStateDirty as any,
);
